export default "__VITE_ASSET__d281e29b__"